import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '@/auth/AuthContext'
import { EngineeringBackdrop } from '@/components/EngineeringBackdrop'
import AuthPage from './AuthPage'

export default function Landing() {
  const { user, loading, signOut } = useAuth()
  const { state } = useLocation() as { state?: { from?: string } }
  if (!loading && user?.role) {
    const home = user.role === 'sme' ? '/sme' : '/eng'
    const from = state?.from
    // Resume a protected link inside the account's workspace. Engineers resume any link: RequireRole sends an /sme one to its /eng page.
    const destination = from && (user.role === 'engineer' || from === home || from.startsWith(`${home}/`) || from.startsWith(`${home}?`)) ? from : home
    return <Navigate to={destination} replace />
  }
  return (
    <div className="landing-page">
      <EngineeringBackdrop />
      <main className="page narrow landing-main">
        {!loading && user ? <section className="box">
          <p role="alert">Your account has no workspace access yet. Contact a developer.</p>
          <button className="ghost" onClick={() => void signOut()}>Sign out</button>
        </section> : <AuthPage mode="login" embedded />}
      </main>
    </div>
  )
}
